/**
 * Every WhatsApp message the site starts is written the same way, the
 * client's wording:
 *
 *   Hello,
 *
 *   Please Contact me regarding Ayurveda Opinion and Appointment <subject>.
 *
 *   Thank You!
 *
 * The subject is the page's own: "at <centre>" on a centre's page, "for
 * <heading>" on a treatment, package, holistic healing or country guide
 * page, a fixed one on the Packages and Holistic Healing listings, and
 * "for Ayurveda Treatment in India" everywhere else. It is filled
 * in at the moment a WhatsApp link is clicked (or middle- or right-clicked,
 * so an opened or copied link has it too), over whatever message the link
 * was written with, so every link on every page follows it.
 */
const GENERAL = "for Ayurveda Treatment in India";
const WHATSAPP_NUMBER = "919156115572";

// listing pages whose heading reads badly in a message ("Best …")
const LISTING_SUBJECTS: Record<string, string> = {
  "/ayurveda-packages": "for Ayurveda Treatment Packages in India",
  "/holistic-healing": "for Holistic Healing Therapies in India",
};

export const whatsappText = (subject: string = GENERAL) =>
  `Hello,\n\nPlease Contact me regarding Ayurveda Opinion and Appointment ${subject}.\n\nThank You!`;

function pageSubject(): string {
  const path = window.location.pathname.replace(/\/+$/, "");
  if (LISTING_SUBJECTS[path]) return LISTING_SUBJECTS[path];
  const heading = (document.querySelector("h1")?.textContent ?? "").replace(/\s+/g, " ").replace(/[.!?]+$/, "").trim();
  if (!heading) return GENERAL;
  // a centre's own page, or the generic centre page at /…/:city/:centerId
  if (/^\/top-ayurvedic-centers-in-india\/([^/]+-india|[^/]+\/[^/]+)$/.test(path)) return `at ${heading}`;
  if (/^\/(ayurveda-treatments|ayurveda-packages|holistic-healing|country-guide)\/[^/]+$/.test(path)) return `for ${heading}`;
  return GENERAL;
}

export function startWhatsAppMessages() {
  const fill = (e: Event) => {
    const a = (e.target as Element | null)?.closest?.('a[href*="wa.me/"]') as HTMLAnchorElement | null;
    if (!a) return;
    let url: URL;
    try {
      url = new URL(a.href);
    } catch {
      return;
    }
    url.searchParams.set("text", whatsappText(pageSubject()));
    // every chat the site starts is with MyVaidyam, whatever number a link was written with
    if (url.hostname === "wa.me") url.pathname = `/${WHATSAPP_NUMBER}`;
    a.href = url.toString();
  };
  for (const type of ["click", "auxclick", "contextmenu"]) document.addEventListener(type, fill, true);
}
